module.exports = __webpack_public_path__ + "static/media/badge.4f899a52.svg";